import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const Mouthpiece = ({ onMouthpieceSelected }) => {
  const [selectedMouthpiece, setSelectedMouthpiece] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.mouthpiece) {
        const mouthpieceObject = firstResult.mouthpiece;
        if (mouthpieceObject.trim() !== "") {
          setVariations(mouthpieceObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleMouthpieceClick = (mouthpiece) => {
    setSelectedMouthpiece(mouthpiece);
    onMouthpieceSelected(mouthpiece);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Mouthpiece:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedMouthpiece === variation ? "selected" : ""}`}
            onClick={() => handleMouthpieceClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default Mouthpiece;
